import Hero from './components/Hero';
import Features from './components/Features';
import ProductDetail from './components/ProductDetail';
import StepGuide from './components/StepGuide';
import Ingredients from './components/Ingredients';
import BeforeAfter from './components/BeforeAfter';
import HowToVideo from './components/HowToVideo';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Features />
      <ProductDetail />
      <StepGuide />
      <Ingredients />
      <BeforeAfter />
      <HowToVideo />
      <Pricing />
      <FAQ />
      <Footer />
    </div>
  );
}
